require('./bootstrap');

document.addEventListener('error', (e) => {
    const img = e.target;
    if (img.tagName === 'IMG' && img.classList.contains('js-identity-icon') && img.dataset.fallback) {
        const fallback = img.dataset.fallback;
        img.removeAttribute('data-fallback');
        img.src = fallback;
    }
}, true);
